var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.MANAGE_PROJECTS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-bold text-lg" }, [
                        _vm._v("Projects"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "ProjectModalWithButton",
          fn: function () {
            return [
              _c("NewProjectsDashboard", {
                staticClass: "flex flex-grow justify-start -ml-29 mb-12",
                attrs: {
                  buttonText: "Create New Project",
                  companyId: _vm.companyId,
                  size: _vm.size,
                  currentUser: _vm.currentUser,
                },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "ProjectsInProgressCard",
          fn: function () {
            return [
              _c("ProjectsInProgressCard", {
                attrs: {
                  projects: _vm.inProgressProjects,
                  currentUser: _vm.currentUser,
                  companyId: _vm.companyId,
                },
                on: { projectUpdated: _vm.refetchCollection },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 items-center text-gray-600",
          attrs: {
            itemNumber: _vm.newProjectsTotal,
            itemTitle: "New Projects",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("ProjectsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.newProjects
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.newProjects, function (project, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: project.name,
                      id: project.id,
                      route: _vm.routes.PROJECT_ACTIVITY,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 items-center text-yellow-300",
          attrs: {
            itemNumber: _vm.inProgressTotal,
            itemTitle: "In Progress",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("ProjectsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.activities
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.activities, function (activity, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: activity.title,
                      id: activity.id,
                      route: _vm.routes.PROJECT_ACTIVITY,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 items-center text-green-400",
          attrs: {
            itemNumber: _vm.projectsCompleted,
            itemTitle: "Completed",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("ProjectsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.projectsToRender
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.projectsToRender, function (project, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: project.name,
                      id: project.id,
                      route: _vm.routes.PROJECT_ACTIVITY,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 items-center text-red-600",
          attrs: { itemNumber: 0, itemTitle: "Cancelled", flexRow: "" },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("ProjectsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.newProjects
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.newProjects, function (project, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: project.name,
                      id: project.id,
                      route: _vm.routes.PROJECT_ACTIVITY,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 items-center text-innerCard-primary",
          attrs: {
            itemNumber: _vm.projectsTotal,
            itemTitle: "Total Projects",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("ProjectsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.projectsToRender
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.projectsToRender, function (project, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: project.name,
                      id: project.id,
                      route: _vm.routes.PROJECT_ACTIVITY,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }